import { messages as resourceAuditFlowMessages } from '../views/resource/resourceAuditFlowLang'
import { messages as storehouseManageMessages } from '../views/resource/storehouseManageLang'
import { messages as resourceStoreSpecificationManageMessages } from '../views/resource/resourceStoreSpecificationManageLang'
import { messages as resourceStoreManageMessages } from '../views/resource/resourceStoreManageLang'

import { messages as resourceSupplierManageMessages } from '../views/resource/resourceSupplierManageLang'
import { messages as purchaseApplyManageMessages } from '../views/resource/purchaseApplyManageLang'
import { messages as addPurchaseApplyMessages } from '../views/resource/addPurchaseApplyLang'
import { messages as urgentPurchaseApplyStepMessages } from '../views/resource/urgentPurchaseApplyStepLang'
import { messages as purchaseApplyDetailMessages } from '../views/resource/purchaseApplyDetailLang'
import { messages as itemOutManageMessages } from '../views/resource/itemOutManageLang'
import { messages as addItemOutMessages } from '../views/resource/addItemOutLang'
import { messages as purchaseApplyDetailManageMessages } from '../views/resource/purchaseApplyDetailManageLang'
import { messages as allocationStorehouseManageMessages } from '../views/resource/allocationStorehouseManageLang'
import { messages as allocationStorehouseApplyMessages } from '../views/resource/allocationStorehouseApplyLang'
import { messages as allocationStorehouseDetailedMessages } from '../views/resource/allocationStorehouseDetailedLang'
import { messages as assetInventoryManageMessages } from '../views/resource/assetInventoryManageLang'
import { messages as myResourceStoreManageMessages } from '../views/resource/myResourceStoreManageLang'
import { messages as allocationUserStorehouseManageMessages } from '../views/resource/allocationUserStorehouseManageLang'
import { messages as resourceStoreUseRecordManageMessages } from '../views/resource/resourceStoreUseRecordManageLang'
import { messages as printEquipmentAccountLabelMessages } from '../views/resource/printEquipmentAccountLabelLang'
import { messages as resourceDetailMessages } from '../views/resource/resourceDetailLang'
import { messages as allocationStorehouseDetailMessages } from '../views/resource/allocationStorehouseDetailLang'
import { messages as printAllocationStorehouseMessages } from '../views/resource/printAllocationStorehouseLang'
import { messages as assetInventoryInMessages } from '../views/resource/assetInventoryInLang'
import { messages as assetInventoryInStockMessages } from '../views/resource/assetInventoryInStockLang' 
import { messages as assetInventoryEditMessages } from '../views/resource/assetInventoryEditLang'
import { messages as assetInventoryAuditMessages } from '../views/resource/assetInventoryAuditLang'
import { messages as printAssetInventoryInStockMessages } from '../views/resource/printAssetInventoryInStockLang'
import { messages as returnStorehouseApplyManageMessages } from '../views/resource/returnStorehouseApplyManageLang'
import { messages as transferGoodsManageMessages } from '../views/resource/transferGoodsManageLang'
import { messages as scrapGoodsStepMessages } from '../views/resource/scrapGoodsStepLang'
import { messages as myAuditOrdersMessages } from '../views/resource/myAuditOrdersLang' 
import { messages as resourceEnterManageMessages } from '../views/resource/resourceEnterManageLang'
import { messages as editPurchaseApplyMessages } from '../views/resource/editPurchaseApplyLang'

import { messages as myItemOutAuditOrdersMessages } from '../views/resource/myItemOutAuditOrdersLang'
import { messages as resourceOutManageMessages } from '../views/resource/resourceOutManageLang'
import { messages as allocationStorehouseAuditOrdersMessages } from '../views/resource/allocationStorehouseAuditOrdersLang'
import { messages as editAllocationStorehouseApplyMessages } from '../views/resource/editAllocationStorehouseApplyLang'
import { messages as allocationStorehouseEnterMessages } from '../views/resource/allocationStorehouseEnterLang'
import { messages as itemReleaseUndoMessages } from '../views/resource/itemReleaseUndoLang'
import { messages as myItemOutAuditHistoryOrdersMessages } from '../views/resource/myItemOutAuditHistoryOrdersLang'
import { messages as allocationStorehouseHistoryAuditOrdersMessages } from '../views/resource/allocationStorehouseHistoryAuditOrdersLang'
import { messages as itemReleaseFinishMessages } from '../views/resource/itemReleaseFinishLang'

export const messages = {
    en: {
        ...resourceAuditFlowMessages.en,
        ...storehouseManageMessages.en,
        ...resourceStoreSpecificationManageMessages.en,
        ...resourceStoreManageMessages.en,
        ...resourceSupplierManageMessages.en,
        ...purchaseApplyManageMessages.en,
        ...addPurchaseApplyMessages.en,
        ...urgentPurchaseApplyStepMessages.en,
        ...purchaseApplyDetailMessages.en,
        ...itemOutManageMessages.en,
        ...addItemOutMessages.en,
        ...purchaseApplyDetailManageMessages.en,
        ...allocationStorehouseManageMessages.en,
        ...allocationStorehouseApplyMessages.en,
        ...allocationStorehouseDetailedMessages.en,
        ...assetInventoryManageMessages.en,
        ...myResourceStoreManageMessages.en,
        ...allocationUserStorehouseManageMessages.en,
        ...resourceStoreUseRecordManageMessages.en,
        ...printEquipmentAccountLabelMessages.en,
        ...resourceDetailMessages.en,
        ...allocationStorehouseDetailMessages.en,
        ...printAllocationStorehouseMessages.en,
        ...assetInventoryInMessages.en,
        ...assetInventoryInStockMessages.en,
        ...assetInventoryEditMessages.en,
        ...assetInventoryAuditMessages.en,
        ...printAssetInventoryInStockMessages.en,
        ...returnStorehouseApplyManageMessages.en,
        ...transferGoodsManageMessages.en,
        ...scrapGoodsStepMessages.en,
        ...myAuditOrdersMessages.en,
        ...resourceEnterManageMessages.en,
        ...editPurchaseApplyMessages.en,
        ...myItemOutAuditOrdersMessages.en,
        ...resourceOutManageMessages.en,
        ...allocationStorehouseAuditOrdersMessages.en,
        ...editAllocationStorehouseApplyMessages.en,
        ...allocationStorehouseEnterMessages.en,
        ...itemReleaseUndoMessages.en,
        ...myItemOutAuditHistoryOrdersMessages.en,
        ...allocationStorehouseHistoryAuditOrdersMessages.en,
        ...itemReleaseFinishMessages.en,
    },
    zh: {
        ...resourceAuditFlowMessages.zh,
        ...storehouseManageMessages.zh,
        ...resourceStoreSpecificationManageMessages.zh,
        ...resourceStoreManageMessages.zh,
        ...resourceSupplierManageMessages.zh,
        ...purchaseApplyManageMessages.zh,
        ...addPurchaseApplyMessages.zh,
        ...urgentPurchaseApplyStepMessages.zh,
        ...purchaseApplyDetailMessages.zh,
        ...itemOutManageMessages.zh,
        ...addItemOutMessages.zh,
        ...purchaseApplyDetailManageMessages.zh,
        ...allocationStorehouseManageMessages.zh,
        ...allocationStorehouseApplyMessages.zh,
        ...allocationStorehouseDetailedMessages.zh,
        ...assetInventoryManageMessages.zh,
        ...myResourceStoreManageMessages.zh,
        ...allocationUserStorehouseManageMessages.zh,
        ...resourceStoreUseRecordManageMessages.zh,
        ...printEquipmentAccountLabelMessages.zh,
        ...resourceDetailMessages.zh,
        ...allocationStorehouseDetailMessages.zh,
        ...printAllocationStorehouseMessages.zh,
        ...assetInventoryInMessages.zh,
        ...assetInventoryInStockMessages.zh,
        ...assetInventoryEditMessages.zh,
        ...assetInventoryAuditMessages.zh,
        ...printAssetInventoryInStockMessages.zh,
        ...returnStorehouseApplyManageMessages.zh,
        ...transferGoodsManageMessages.zh,
        ...scrapGoodsStepMessages.zh,
        ...myAuditOrdersMessages.zh,
        ...resourceEnterManageMessages.zh,
        ...editPurchaseApplyMessages.zh,
        ...myItemOutAuditOrdersMessages.zh,
        ...resourceOutManageMessages.zh,
        ...allocationStorehouseAuditOrdersMessages.zh,
        ...editAllocationStorehouseApplyMessages.zh,
        ...allocationStorehouseEnterMessages.zh,
        ...itemReleaseUndoMessages.zh,
        ...myItemOutAuditHistoryOrdersMessages.zh,
        ...allocationStorehouseHistoryAuditOrdersMessages.zh,
        ...itemReleaseFinishMessages.zh,
    }
}